import * as constants from './PlvLiveLogin.constants';
import * as services from './PlvLiveLogin.service';

const state = {
  plvWatchLink: {},

  errorCode: 0,
  errorMsg: '',

  isRequest: false,
};

const mutations = {
  [constants.GET_PLV_WATCH_LINK_SUCCESS](state, plvWatchLink) {
    if (undefined !== plvWatchLink && null !== plvWatchLink) {
      state.plvWatchLink = plvWatchLink;
    }
  },

  [constants.SET_ERROR](state, data) {
    state.errorCode = data.status;
    state.errorMsg = data.message;
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getPlvWatchLink({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getPlvWatchLink(payload);
    if (500 === res.data.status) {
      commit(constants.SET_ERROR, res.data);
    } else {
      commit(constants.GET_PLV_WATCH_LINK_SUCCESS, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
